<header>
  <h4>{{ 'content_details.views_distribution.title' | translate }}</h4>
  <kin-icon
    name="information"
    [color]="colorService.brandSecondary400()"
    [tooltip]="'content_details.views_distribution.tooltip' | translate"
    tooltipPosition="top"
  />
</header>
@if (loading()) {
  <div class="skeleton-container">
    <kin-skeleton class="doughnut-skeleton" [height]="17" [width]="17" [borderRadius]="50" />
    <ul>
      @for (i of [].constructor(10); track $index) {
        <li>
          <kin-skeleton [width]="1.5" [height]="1.5" [borderRadius]="0.5" />
          <kin-skeleton [width]="8" [height]="1.3" [borderRadius]="0.5" />
        </li>
      }
    </ul>
  </div>
} @else if (chartData().length > 0) {
  <kin-doughnut-chart
    [metrics]="'vues'"
    [data]="chartData()"
    [label]="chartLabels()"
    [legendOptions]="legendOptions()"
  />
} @else {
  <p>{{ 'content.message.empty_data' | translate }}</p>
}
